import r from"./memoize.js";var e=500;function t(t){var a=r(t,(function(r){return n.size===e&&n.clear(),r})),n=a.cache;return a}export{t as default};
//# sourceMappingURL=_memoizeCapped.js.map
